// extracted by mini-css-extract-plugin
module.exports = {"link_gravatar":"Avatar_link_gravatar__1QRlS","AvatarImage":"Avatar_AvatarImage__2X-mq","AvatarMaskedImage":"Avatar_AvatarMaskedImage__QgpcB"};